import PrescriptionDetailsPage from "./PrescriptionDetailsPage";

export default PrescriptionDetailsPage;

export * from "./PrescriptionDetailsPage";
